import { render } from "./EffectsComponent.vue?vue&type=template&id=316fa871&scoped=true"
import script from "./EffectsComponent.vue?vue&type=script&lang=js"
export * from "./EffectsComponent.vue?vue&type=script&lang=js"

import "./EffectsComponent.vue?vue&type=style&index=0&id=316fa871&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316fa871"]])

export default __exports__